import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { LoginPage } from "./pages/LoginPage.js";
import { DashboardPage } from "./pages/DashboardPage.js";
import { PackagesPage } from "./pages/PackagesPage.js";
import { PackageDetailPage } from "./pages/PackageDetailPage.js";
import { ReviewPage } from "./pages/ReviewPage.js";
import { AdminsPage } from "./pages/AdminsPage.js";
import { AuditPage } from "./pages/AuditPage.js";
import { AppShell } from "./components/AppShell.js";
import { getToken } from "./lib/auth.js";

/**
 * mhwork-hub admin 路由树。
 * 未登录 → 踢到 /login;登录后进 AppShell + 各页面。
 * role gate(owner/reviewer/publisher/viewer)由各页面自己决定。
 */
export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireAuth />}>
        <Route element={<AppShell />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/packages" element={<PackagesPage />} />
          <Route path="/packages/:name" element={<PackageDetailPage />} />
          <Route path="/review" element={<ReviewPage />} />
          <Route path="/admins" element={<AdminsPage />} />
          <Route path="/audit" element={<AuditPage />} />
        </Route>
      </Route>
    </Routes>
  );
}

function RequireAuth() {
  const token = getToken();
  if (!token) return <Navigate to="/login" replace />;
  return <Outlet />;
}
